import { FlowChartIcon } from 'common/builder/components/chart/FlowChart/types/FlowChartIcon'
import { FlowChartContentNodeHeader } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNodeHeader'

export class FlowChartContentNodeHeaderBuilder {
  private icon: FlowChartIcon
  private title: string
  private subtitle: string | null = null
  private rightIcon: FlowChartIcon | null = null
  private additionalIcon: FlowChartIcon | null = null

  constructor(title: string, icon: FlowChartIcon) {
    this.icon = icon
    this.title = title
  }

  withSubtitle(subtitle: string | null): FlowChartContentNodeHeaderBuilder {
    this.subtitle = subtitle
    return this
  }

  withRightIcon(rightIcon: FlowChartIcon | null): FlowChartContentNodeHeaderBuilder {
    this.rightIcon = rightIcon
    return this
  }

  withAdditionalIcon(additionalIcon: FlowChartIcon | null): FlowChartContentNodeHeaderBuilder {
    this.additionalIcon = additionalIcon
    return this
  }

  build(): FlowChartContentNodeHeader {
    return {
      icon: this.icon,
      title: this.title,
      subtitle: this.subtitle,
      rightIcon: this.rightIcon,
      additionalIcon: this.additionalIcon,
    }
  }
}
